import React from "react";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  AlertCircle,
  GraduationCap,
  Sprout,
} from "lucide-react";
import Dashboard from "./pages/Dashboard";
import Classes from "./pages/Classes";
import ClassDetail from "./pages/ClassDetail";
import Students from "./pages/Students";
import StudentDetail from "./pages/StudentDetail";
import FollowUps from "./pages/FollowUps";
import FruitStatus from "./pages/FruitStatus";
import Homework from "./pages/Homework";

function AppLayout() {
  const location = useLocation();

  // Public homework page — no sidebar
  if (location.pathname.startsWith("/hw/")) {
    return (
      <Routes>
        <Route path="/hw/:classId" element={<Homework />} />
      </Routes>
    );
  }

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <h1>MOT</h1>
          <div className="brand-sub">Student Management</div>
        </div>
        <nav>
          <NavLink to="/" end>
            <LayoutDashboard size={18} /> Dashboard
          </NavLink>
          <NavLink to="/classes">
            <GraduationCap size={18} /> Classes
          </NavLink>
          <NavLink to="/students">
            <Users size={18} /> Students
          </NavLink>
          <NavLink to="/follow-ups">
            <AlertCircle size={18} /> Follow-ups
          </NavLink>
        </nav>
        <div className="sidebar-footer">
          v1.0
        </div>
      </aside>
      <main className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/classes/:id" element={<ClassDetail />} />
          <Route path="/students" element={<Students />} />
          <Route path="/students/:id" element={<StudentDetail />} />
          <Route path="/follow-ups" element={<FollowUps />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
